// Live's "Save Prompt" (spec G12): a saved picture of a simple generation becomes a prompt
// template of the brand. Shared by My Generations' image cards and the library's card menu
// (S1 decision 22), so it lives here.
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import {
  getListPromptTemplatesQueryKey,
  savePromptTemplate,
} from "../../api/generated/endpoints/generation/generation";

/** Live's SIMPLE generations: the pictures a template may be saved from (G12). */
export const SIMPLE_TYPES: readonly string[] = ["image.simple", "image.tweak"];

/** Live's toast after a save (`useSaveCreativePrompt`), said where the save was asked. */
export const PROMPT_SAVED = "Prompt saved successfully";

/** How long live's toast stays: react-toastify's `autoClose`, which live keeps. */
export const PROMPT_SAVED_MS = 5000;

/**
 * Live's "Save Prompt" for a row's cards: a saved picture becomes a template of the brand, the
 * Custom tab is read again, and `said` names the picture for live's 5 s. As live's, the control
 * stays "Save Prompt": a picture with a template already is live's 409, whose words are `error`
 * with any other refusal, for the row to show where it shows its own.
 */
export function useSavePrompt(teamId: string, brandId: string) {
  const queryClient = useQueryClient();
  // The picture whose save is being said.
  const [said, setSaid] = useState<string | null>(null);
  useEffect(() => {
    if (said === null) return;
    const timer = setTimeout(() => setSaid(null), PROMPT_SAVED_MS);
    return () => clearTimeout(timer);
  }, [said]);
  const save = useMutation({
    mutationFn: (assetId: string) => savePromptTemplate(teamId, brandId, { asset_id: assetId }),
    onSuccess: (_done, assetId) => {
      setSaid(assetId);
      return queryClient.invalidateQueries({
        queryKey: getListPromptTemplatesQueryKey(teamId, brandId),
      });
    },
  });
  return {
    save: (assetId: string) => {
      setSaid(null);
      save.mutate(assetId);
    },
    /** The picture whose save live's toast is saying, for its 5 s. */
    said,
    /** The picture whose save is on its way. */
    pending: save.isPending ? save.variables : undefined,
    error: save.isError ? save.error : null,
  };
}

export type SavePrompt = ReturnType<typeof useSavePrompt>;
